import { makeStyles, createStyles, Theme, SvgIcon } from "@material-ui/core";

import { Edit } from "~components/Icons";

export type EditButtonProps = {
  onEdit: () => void;
};

// TODO use Mui Button component here
export const EditButton = ({ onEdit }: EditButtonProps) => {
  const classes = useStyles();

  return (
    <div className={classes.edit} onClick={onEdit} role="button">
      <SvgIcon component={Edit} color="primary" className={classes.editIcon} viewBox="0 0 12 12" />
      EDIT
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    edit: {
      cursor: "pointer",
      fontSize: 12,
      fontWeight: "bold",
      lineHeight: 1.58,
      letterSpacing: 1,
      textAlign: "right",
      color: theme.palette.primary.main,
      marginLeft: theme.spacing(1.25),
      fontFamily: theme.typography.fontFamily,
      display: "flex",
    },
    editIcon: {
      fontSize: 16,
      marginLeft: 4,
      marginRight: 4,
    },
  }),
);
